import React from 'react'
import PropTypes from 'prop-types'

import styles from './ContentBlock.module.styl'

const ContentBlock = (props) => {

  return (
    <section
      style={props.style}
      className={[
        styles.contentBlock,
        props.center ? styles.center : null,
        props.split ? styles.split : null,
        props.reverse ? styles.reverse : null,
        props.antiReverse ? styles.antiReverse : null,
        props.noMinHeight ? styles.noMinHeight : null,
        props.noPadding ? styles.noPadding : null,
        props.sliderLeft ? styles.sliderLeft : null,
        props.sliderRight ? styles.sliderRight : null,
        props.paragraphColumns ? styles.paragraphColumns : null,
        props.darkBackground ? styles.darkBackground : null,
        props.darkBackgroundLeft ? styles.darkBackgroundLeft : null,
        props.darkBackgroundRight ? styles.darkBackgroundRight : null
      ].join(' ')}
    >
      {props.children}
    </section>
  )
}

ContentBlock.propTypes = {
  antiReverse: PropTypes.bool,
  center: PropTypes.bool,
  darkBackground: PropTypes.bool,
  darkBackgroundLeft: PropTypes.bool,
  darkBackgroundRight: PropTypes.bool,
  noMinHeight: PropTypes.bool,
  noPadding: PropTypes.bool,
  paragraphColumns: PropTypes.bool,
  reverse: PropTypes.bool,
  sliderLeft: PropTypes.bool,
  sliderRight: PropTypes.bool,
  split: PropTypes.bool,
  style: PropTypes.object,
}

ContentBlock.defaultProps = {
  
}

export default ContentBlock



// WEBPACK FOOTER //
// ./src/components/ContentBlock/ContentBlock.js